import { Quill } from 'react-quill';

import { IReactQuillDelta } from '../APIPackage/KnmModule/interfaces/IReactQuillDelta';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let quillInstance: any = null;

const htmlCache = new Map<string, string>();
const MAX_CACHE_SIZE = 100;

const getQuillInstance = () => {
  if (!quillInstance) {
    const container = document.createElement('div');

    quillInstance = new Quill(container, {
      readOnly: true,
    });
  }

  return quillInstance;
};

export const convertQuillDeltaToHtml = (delta: IReactQuillDelta) => {
  try {
    const cacheKey = JSON.stringify(delta);

    if (htmlCache.has(cacheKey)) {
      return htmlCache.get(cacheKey)!;
    }

    const quill = getQuillInstance();

    quill.setContents(delta || []);

    const html = quill.root.innerHTML;

    if (htmlCache.size >= MAX_CACHE_SIZE) {
      const firstKey = htmlCache.keys().next().value;

      htmlCache.delete(firstKey);
    }
    htmlCache.set(cacheKey, html);

    return html;
  } catch (error) {
    console.error('Error converting delta to HTML:', error);

    return '';
  }
};
